import { render, staticRenderFns } from "./apartment-location-project-gallery.vue?vue&type=template&id=47c23e57&scoped=true&"
import script from "./apartment-location-project-gallery.ts?vue&type=script&lang=ts&"
export * from "./apartment-location-project-gallery.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-location-project-gallery.scss?vue&type=style&index=0&id=47c23e57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c23e57",
  null
  
)

export default component.exports